import type { Ref } from "react";
import { forwardRef } from "react";

import type { BoxProps } from "../../../Box/Box";
import { Box } from "../../../Box/Box";
import type { FieldProps } from "../../../Field/Field";
import { Field } from "../../../Field/Field";
import { HintText } from "../../../HintText/HintText";

type Props = {
  visuallyHiddenHint: string;
  hint: string;
  styles: BoxProps["styles"];
} & FieldProps;

function FieldWithHint(
  { visuallyHiddenHint, hint, styles, disabled, ...fieldProps }: Props,
  ref: Ref<HTMLInputElement>
) {
  return (
    <Box
      as="label"
      display="flex"
      flexDirection="column"
      flexShrink={0}
      styles={{
        ...styles,
        pointerEvents: disabled ? "none" : "all",
      }}
    >
      <Box as={HintText} mb="datepickerHintMarginBottom">
        {hint}
      </Box>
      <Field
        {...fieldProps}
        aria-placeholder={visuallyHiddenHint}
        ref={ref}
        aria-autocomplete="none"
        autoComplete="off"
        inputMode="numeric"
        style={{
          textOverflow: "ellipsis",
          fontFeatureSettings: '"tnum"',
        }}
        disabled={disabled}
      />
    </Box>
  );
}

export default forwardRef(FieldWithHint);
